// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"Toolbar_NavBar__r9INs","DesktopOnly":"Toolbar_DesktopOnly__LuPaL"};